import { styled } from 'baseui'
import { FlexCenterY } from '@/shared/theme/styled-components'

const PULSE_TONES = {
  positive: 'Ok',
  unlocked: 'Ok',
  warning: 'Warn',
  locked: 'Warn',
  negative: 'Err',
  error: 'Err',
  script: 'Script',
  agentScript: 'Script',
  additionalSale: 'AddSale',
}

export const pulseNoticeColors = ($theme, type) => {
  const tone = PULSE_TONES[type] ?? 'Info'

  return {
    text: $theme.colors[`notice${tone}Text`],
    bg: $theme.colors[`notice${tone}Bg`],
  }
}

const pulseNotificationStyle = ($theme, $type, $boldText) => {
  const { text, bg } = pulseNoticeColors($theme, $type)

  return {
    backgroundColor: bg,
    color: text,
    borderTopLeftRadius: '8px',
    borderTopRightRadius: '8px',
    borderBottomLeftRadius: '8px',
    borderBottomRightRadius: '8px',
    paddingTop: '10px',
    paddingBottom: '10px',
    paddingLeft: '12px',
    paddingRight: '12px',
    fontSize: '13px',
    lineHeight: '19px',
    fontWeight: $boldText ? 600 : 400,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: '10px',
    width: '100%',
    boxSizing: 'border-box',
    marginBottom: '0.5rem',
  }
}

export const StyledNotification = styled('div', ({ $theme, $type, $boldText, $border, $pulse }) => {
  if ($pulse) return pulseNotificationStyle($theme, $type, $boldText)

  const outputColour = {}
  let borderStyle = 'solid'

  switch ($type) {
    case 'negative':
      outputColour.text = $theme.colors.negative
      outputColour.bg = $theme.colors.negative150
      outputColour.shadow = $theme.colors.negative400
      break
    case 'error':
      outputColour.text = $theme.colors.negative
      outputColour.bg = '#FBEAE6'
      outputColour.shadow = $theme.colors.negative
      borderStyle = 'dashed'
      break
    case 'info':
      outputColour.text = $theme.colors.grey
      outputColour.bg = $theme.colors.bg050
      outputColour.shadow = $theme.colors.primary400
      borderStyle = 'dashed'
      break
    case 'positive':
      outputColour.text = $theme.colors.grey
      outputColour.bg = $theme.colors.successBg
      outputColour.shadow = $theme.colors.positive400
      break
    case 'warning':
    case 'additionalSale':
      outputColour.text = $theme.colors.grey
      outputColour.bg = $theme.colors.warning150
      outputColour.shadow = $theme.colors.warning300
      borderStyle = 'dashed'
      break
    case 'script':
    case 'agentScript':
    default:
      outputColour.text = $theme.colors.grey
      outputColour.bg = $theme.colors.bg050
      outputColour.shadow = $theme.colors.primary400
      borderStyle = 'dashed'
      break
  }

  return {
    backgroundColor: outputColour.bg,
    color: outputColour.text,
    borderTopLeftRadius: $theme.borders.radius200,
    borderTopRightRadius: $theme.borders.radius200,
    borderBottomLeftRadius: $theme.borders.radius200,
    borderBottomRightRadius: $theme.borders.radius200,
    border: $border ? `1px ${borderStyle} ${outputColour.shadow}` : 'none',
    paddingTop: '.5rem',
    paddingBottom: '.5rem',
    paddingLeft: '.5rem',
    paddingRight: '.5rem',
    ...$theme.typography.ParagraphXSmall,
    fontWeight: $boldText ? 'bold' : 'normal',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: '100%',
    marginBottom: '0.5rem',
  }
})

export const NotificationContent = styled('div', ({ $centerText, $pulse }) => ({
  display: 'flex',
  justifyContent: $centerText ? 'center' : 'flex-start',
  width: '100%',
  gap: $pulse ? '10px' : '.5rem',
}))

export const IconWrapper = styled('div', ({ $pulse }) => ({
  flex: '0 0 auto',
  ...($pulse ? { display: 'flex', marginTop: '1px' } : {}),
}))

export const TextWrapper = styled(FlexCenterY, ({ $theme, $centerText, $pulse }) => ({
  ...($pulse ? { fontSize: '13px', lineHeight: '19px' } : $theme.typography.ParagraphSmall),
  flex: $centerText ? '0 0 auto' : '1 1 auto',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: 0,
  marginRight: 0,
  paddingTop: 0,
  paddingBottom: 0,
  paddingLeft: 0,
  paddingRight: 0,
  textAlign: $centerText ? 'center' : 'left',
  width: 'auto',
  letterSpacing: '-0.084px',
}))

export const NotificationActions = styled('div', ({ $theme, $pulse }) => ({
  width: '100%',
  marginTop: $pulse ? 0 : $theme.sizing.scale400,
  display: 'flex',
}))
